module.exports = __webpack_public_path__ + "static/media/Sam-realEstate_160px.c34ba8bc.jpg";